import { useStore } from "stook";

interface ITrailerAddress {
  province?: string; // 省份
  city?: string; //市
  district?: string; // 区
  address: string; //救援详细地址
  locationLat: number;
  locationLon: number;
  trailerShopCode?: string; // 拖车门店编码
  trailerShopName?: string; // 拖车门店名称
}
let INIT_ADDRESS_DATA: ITrailerAddress = {
  province: "",
  city: "",
  district: "",
  address: "",
  locationLat: 0,
  locationLon: 0,
};

if (process.env.REACT_APP_DELOY_ENV === "test") {
  INIT_ADDRESS_DATA = {
    province: "广东省",
    city: "广州市",
    district: "天河区",
    address: "广东省广州市天河区小鹏汽车广州信达金茂销售展厅",
    locationLon: 113.385925,
    locationLat: 23.153875,
  };
}

export default function useTrailerAddress() {
  const [trailerAddress, setTrailerAddress] = useStore<ITrailerAddress>(
    "trailerAddress",
    INIT_ADDRESS_DATA,
  );

  const resetTrailerAddressInfo = () => {
    setTrailerAddress(INIT_ADDRESS_DATA);
  };

  return {
    trailerAddress,
    setTrailerAddress,
    resetTrailerAddressInfo,
  };
}
